var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonal = function SvgPersonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: 10
    },
    viewBox: "0 0 52 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 47.807,
    y: 0.096,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M39.872 26.45a7.422 7.422 0 1 1-10.358 10.358l-2.762 2.762a1.06 1.06 0 0 1-1.499 0L10.95 25.267c-3.923-3.923-3.933-10.278-.03-14.212 3.973-3.942 10.33-3.932 14.253-.01l.83.83.83-.83c3.922-3.922 10.28-3.932 14.212-.03 3.944 3.974 3.933 10.33.01 14.252zM26.003 37.32l2.498-2.498a7.421 7.421 0 0 1 9.386-9.386l1.67-1.669c3.104-3.104 3.105-8.138.02-11.224a7.953 7.953 0 0 0-11.244.001l-1.58 1.58a1.06 1.06 0 0 1-1.5 0l-1.58-1.58c-3.103-3.104-8.14-3.104-11.224-.02a7.95 7.95 0 0 0 .001 11.244zm9.542.462a5.301 5.301 0 1 0 0-10.603 5.301 5.301 0 0 0 0 10.603m-1.06-6.361v-1.06a1.06 1.06 0 0 1 2.12 0v1.06h1.06a1.06 1.06 0 1 1 0 2.12h-1.06v1.06a1.06 1.06 0 0 1-2.12 0v-1.06h-1.06a1.06 1.06 0 1 1 0-2.12z"
  })));
};
export default SvgPersonal;